export default "__VITE_ASSET__CskxMPD___"